module.exports = __webpack_public_path__ + "img/14_44.5250be41.png";